import { QueryHookOptions } from '@apollo/client';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useAllPartnersQuery } from '@anytag/graphql';

export const useAllPartnerOptions = (options?: QueryHookOptions<Query>) => {
  const { data, loading } = useAllPartnersQuery({ fetchPolicy: 'cache-and-network', ...options });

  return {
    loading,
    allPartnerOptions: getSelectOptions(data?.allPartners)
  };
};
